import React from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  BoxProps,
  Link,
} from "@catchoftheday/cg-components";

import { NavigationLinkColumns } from "../../types";
import { Body } from "../primitives";

type AccordionNavigationProps = {
  navigationLinkColumns: NavigationLinkColumns[];
} & BoxProps;

export function AccordionNavigation({
  navigationLinkColumns,
  ...boxProps
}: AccordionNavigationProps) {
  return (
    <Box as="nav" {...boxProps}>
      {navigationLinkColumns.map(({ columnTitle, links }, accordionIndex) => (
        <Accordion key={columnTitle} showDividerTop={accordionIndex === 0}>
          <AccordionSummary align="center">
            {columnTitle.toUpperCase()}
          </AccordionSummary>
          <AccordionDetails
            display="flex"
            flexDirection="column"
            alignItems="center"
            paddingTop="0"
          >
            {links.map(({ text, url, openInNewWindow }) => (
              <Link
                key={text}
                target={openInNewWindow ? "_blank" : undefined}
                rel={openInNewWindow ? "noopener noreferrer" : undefined}
                href={decodeURIComponent(url)}
                marginBottom="0.29rem"
                padding="0.66rem 0"
              >
                <Body margin={0}>{text}</Body>
              </Link>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}
